'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _H = require('./H1');

var _H2 = _interopRequireDefault(_H);

var _H3 = require('./H2');

var _H4 = _interopRequireDefault(_H3);

var _H5 = require('./H3');

var _H6 = _interopRequireDefault(_H5);

var _H7 = require('./H4');

var _H8 = _interopRequireDefault(_H7);

var _H9 = require('./H5');

var _H10 = _interopRequireDefault(_H9);

var _H11 = require('./H6');

var _H12 = _interopRequireDefault(_H11);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Components


var Heading = function Heading(_ref) {
  var children = _ref.children,
      size = _ref.size,
      bold = _ref.bold,
      grey = _ref.grey,
      light = _ref.light;

  switch (size) {
    case '1':
      return _react2.default.createElement(_H2.default, {
        bold: bold,
        grey: grey,
        light: light
      }, children);

    case '2':
      return _react2.default.createElement(_H4.default, {
        bold: bold,
        grey: grey,
        light: light
      }, children);

    case '3':
      return _react2.default.createElement(_H6.default, {
        bold: bold,
        grey: grey,
        light: light
      }, children);

    case '4':
      return _react2.default.createElement(_H8.default, {
        bold: bold,
        grey: grey,
        light: light
      }, children);

    case '5':
      return _react2.default.createElement(_H10.default, {
        bold: bold,
        grey: grey,
        light: light
      }, children);

    case '6':
      return _react2.default.createElement(_H12.default, {
        bold: bold,
        grey: grey,
        light: light
      }, children);

    default:
      return _react2.default.createElement(_H2.default, {
        bold: bold,
        grey: grey,
        light: light
      }, children);
  }
};

Heading.propTypes = {
  children: _propTypes2.default.node.isRequired,
  size: _propTypes2.default.oneOf(['1', '2', '3', '4', '5', '6']),
  bold: _propTypes2.default.bool,
  light: _propTypes2.default.bool,
  grey: _propTypes2.default.bool
};
Heading.defaultProps = {
  size: '1',
  bold: false,
  grey: false,
  light: false
};
exports.default = Heading;